import ActivateOffer from './ActivateOffer';

export default ActivateOffer;
